import React, { useState, useEffect } from 'react';
import { Button } from 'quantux-ui';
import { blue, salmon } from '../../theme';
import { titleCase, calculateAge } from '../../utils';

const _padZero = (val) => {
  if (val < 10) {
    return `0${val}`;
  }
  return val;
};

const PatientCard = (props) => {
  const [canAddPatient, setCanAddPatient] = useState(false);

  const {
    avatar,
    dob,
    gender,
    ssn1,
    ssn2,
    ssn3,
    userName,
    firstName,
    lastName,
    isTempPatient
  } = props.patientData;

  // Effects
  useEffect(() => {
    setCanAddPatient(firstName.length > 0 && lastName.length > 0 && dob.length > 0 && gender.length > 0);
  }, [props.patientData]);

  let tmpDob;
  let age;
  if (dob.length > 0) {
    tmpDob = new Date(Date.parse(dob));
    age = calculateAge(`${_padZero(tmpDob.getMonth() + 1)}/${_padZero(tmpDob.getDate())}/${tmpDob.getFullYear()}`);
  }

  let patientGender = '?';
  if (gender.length > 0 && gender.trim().toLowerCase() === 'male') {
    patientGender = 'M';
  }
  if (gender.length > 0 && gender.trim().toLowerCase() === 'female') {
    patientGender = 'F';
  }

  return (
    <div
      style={{
        background: '#004080',
        margin: '16px 0',
        fontSize: '14px',
        padding: '8px'
      }}
    >
      {/* Top portion */}
      <div style={{ display: 'flex' }}>
        <div>
          <img
            src={avatar || 'https://quantumtrader.s3.amazonaws.com/default-user-avatar.svg'}
            alt='Patient Avatar'
            style={{ width: '48px', height: '48px' }}
          />
        </div>
        <div
          className='ml-2'
          style={{ lineHeight: '16px' }}
        >
          {/* Patient Name */}
          <div>
            <span style={{ color: 'white' }}>{`${titleCase(firstName)} ${titleCase(lastName)}`}</span>
            <span style={{ color: blue[500], marginLeft: '8px', display: isTempPatient ? 'none' : '' }}>{`@${userName}`}</span>
          </div>
          {/* Patient DOB, age and gender */}
          {dob.length > 0
            ? <div>
                {`${_padZero(tmpDob.getMonth() + 1)}/${_padZero(tmpDob.getDate())}/${tmpDob.getFullYear()}, ${age} ${patientGender}`}
              </div>
            : <div>
                mm/dd/yyyy, ?y
              </div>
          }
          {/* Patient SSN */}
          <div>
            {`(SSN ${!isNaN(ssn1) && ssn1.length === 3 ? 'XXX' : '???'}-${!isNaN(ssn2) && ssn2.length === 2 ? 'XX' : '??'}-${!isNaN(ssn3) && ssn3.length === 4 ? ssn3 : '????'})`}
          </div>
        </div>
      </div>
      {/* Bottom portion */}
      <div>
        {canAddPatient
          ? <Button
              btnType='primary'
              onClick={() => {
                if (props.isSchedule) {
                  props.onAddPatient(props.patientData);
                } else {
                  props.onAddPatient(props.patientData._id, props.patientData.isTempPatient);
                }
              }}
              style={{ width: '323px', marginTop: '14px' }}
            >
              {isTempPatient ? 'Create Profile & Add Patient' : 'Add Patient'}
            </Button>
          : <div
              style={{
                color: salmon[500],
                fontSize: '14px',
                fontWeight: '700',
                padding: '8px 0',
                textAlign: 'center'
              }}
            >
              Not enough information to create profile
            </div>
        }
      </div>
    </div>
  );
};

PatientCard.defaultProps = {
  isSchedule: false
};

export default PatientCard;
